export default __webpack_public_path__ + "static/media/paloateparo5.0123ef90.jpg";